import { render, staticRenderFns } from "./PackageCreation.vue?vue&type=template&id=36e43352&scoped=true&"
import script from "./PackageCreation.vue?vue&type=script&lang=js&"
export * from "./PackageCreation.vue?vue&type=script&lang=js&"
import style0 from "./PackageCreation.vue?vue&type=style&index=0&id=36e43352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e43352",
  null
  
)

export default component.exports